import { DialogsUtils } from "@/core/utils/layout/dialogs.utils";
import { MessagesUtils } from "@/core/utils/layout/messages.utils";
import { SessionService } from "@/core/services/security/session.service";
import { inject, Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class UserProfileModalService {
    private dialogsUtils = inject(DialogsUtils);
    private sessionService = inject(SessionService);
    private messagesUtils = inject(MessagesUtils);
    private isModalOpen = false;

    async openLoggedUserProfile(): Promise<void> {
        if (this.isModalOpen) {
            return;
        }

        const user = this.sessionService.getInstance()?.user;
        if (!user?.id) {
            this.messagesUtils.showMessageErrorToast("messages.error.userNotAuthenticated");
            return;
        }

        try {
            this.isModalOpen = true;
            const { PerfilUsuarioModalComponent } = await import(
                "@/components/security/perfil-usuario-modal/perfil-usuario-modal.component"
            );
            const modal = await this.dialogsUtils.openDialogModal(
                PerfilUsuarioModalComponent,
                "components.perfilUsuarioModal.title",
                "70%",
                { id: user.id },
                "perfil-usuario-dialog",
            );
            modal.onClose.subscribe(() => {
                this.isModalOpen = false;
            });
        } catch (error) {
            console.error("Erro ao abrir o modal de perfil do usuário", error);
            this.isModalOpen = false;
        }
    }
}
